import {Injectable} from '@angular/core';
import {Subject, throwError} from 'rxjs';
import {UvmApi} from './uvm.api';
import {Headers, Http} from '@angular/http';
import {catchError, map} from 'rxjs/operators';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class GetApplicationsService {
  public apps = new Subject<any>();
  private uvmApi: UvmApi;

  constructor(private http: Http, private cookieService: CookieService) {
    this.uvmApi = UvmApi.Singleton;
  }

  /**
   * This method returns all the applications for a given user
   */

  getUserApps() {
    let headers: Headers;
    headers = this.uvmApi.headers;
    headers.append('AuthenticationType', 'UVM');
    headers.append('Authorization', 'Bearer ' + this.cookieService.get('UVMAppLoggedInToken'));
    return this.http
      .get((this.uvmApi.url + '/admissions/1.0/getUVMOpp/User'), {headers})
      .pipe(
        map(res => res.json()),
        catchError((error: Response) => throwError(error))
      );
  }

  /**
   * This method returns all the applications
   */

  getAllApps() {
    let headers: Headers;
    headers = this.uvmApi.headers;
    headers.append('AuthenticationType', 'UVM');
    headers.append('Authorization', 'Bearer ' + this.cookieService.get('UVMAppLoggedInToken'));
    return this.http
      .get((this.uvmApi.url + '/admissions/1.0/getUVMOpp/All'), {headers})
      .pipe(
        map(res => res.json()),
        catchError((error: Response) => throwError(error))
      );
  }


  /**
   * Stores in the variable all the response from the API for uvm
   * @param value The response (JSON) from the backend
   */
  updateCache(value) {
    this.apps.next(value);
  }
}
